import type { Model, RoundPlate } from 'metalworks-domain'

import { GenericDimensionInput } from '@salsita-ai/platform-project-sdk/react'
import { EntityPanel, PropertyContainer } from '@salsita-ai/platform-project-sdk/ui'

import {
  FinishDirectionProperty,
  FinishProperty,
  HandingProperty,
  MaterialSwatchProperty,
  NonStandardMaterialWarningWrapper,
  PowderCoatingProperty,
  PowderCoatingWarningWrapper,
  ThicknessProperty,
} from './shared-property-page-components'

interface Props {
  id: RoundPlate['id']
  standard: boolean
  hasFinishDirection: boolean
  powderCoating: boolean
  $bend: Model.CustomBend | null
}

export const RoundPlatePropertyPage = (props: Props) => {
  const { id, standard, hasFinishDirection, powderCoating } = props

  return (
    <EntityPanel.Layout
      additionalAction={null}
      header={
        <EntityPanel.Header
          title="Round Plate"
          description="Customise your round plate. You can change the diameter and thickness of your plate and select your preferred material."
          previewImage={undefined}
          primaryButton={null}
          secondaryButton={null}
        />
      }
    >
      <PropertyContainer.Group spacing="large">
        <MaterialSwatchProperty id={id} />
        <PowderCoatingProperty id={id} />
        <PowderCoatingWarningWrapper powderCoating={powderCoating} />
        <FinishProperty id={id} />
        {hasFinishDirection && <FinishDirectionProperty id={id} />}
        <HandingProperty id={id} />
        <ThicknessProperty id={id} />
        <NonStandardMaterialWarningWrapper standard={standard} />

        <PropertyContainer.Item title="Diameter">
          <GenericDimensionInput entityId={id} instanceName="diameter" />
        </PropertyContainer.Item>
      </PropertyContainer.Group>
    </EntityPanel.Layout>
  )
}
